module.exports = __webpack_public_path__ + "img/chart-bar-solid.ff7b2478.svg";